const bonusLeaveColumns = [
  {
    title: "No.",
    dataIndex: "no",
    key: "no",
    scopedSlots: { customRender: "no" },
    width: 60,
    align: "center",
  },
  {
    title: "Name",
    key: "name",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "Division",
    key: "division",
    customCell() {
      return {
        style: {
          fontWeight: "bold",
        },
      };
    },
    customRender(value) {
      return value?.employee?.division_name?.name ?? "";
    },
    width: 230,
  },
  {
    title: "Role",
    key: "role",
    customRender(value) {
      return value?.employee?.role ?? "";
    },
    width: 120,
  },
  {
    title: "Leave Hour(s)",
    key: "leaveHour",
    customRender(value) {
      return value?.leaveHour?.toFixed(2) ?? 0;
    },
    align: "right",
    width: 120,
  },
  {
    title: "Used",
    key: "used",
    align: "right",
    customRender(value) {
      return value?.usedHours?.toFixed(2) ?? 0.0;
    },
    width: 100,
  },
  {
    title: "Remaining",
    key: "remain",
    align: "right",
    customRender(value) {
      return value?.remainHours?.toFixed(2) ?? 0.0;
    },
    width: 100,
  },
  {
    title: "Expired",
    key: "Expired",
    align: "right",
    customRender(value) {
      return value?.expiredHours?.toFixed(2) ?? 0.0;
    },
    width: 100,
  },
  {
    title: "Note",
    dataIndex: "description",
    width: 250,
    ellipsis: true,
  },
  {
    title: "Date Applied",
    key: "date_applied",
    dataIndex: "applyDate",
    width: 140,
    align: "center",
  },
  {
    title: "Date Expired",
    key: "date_expired",
    dataIndex: "expireDate",
    width: 140,
    align: "center",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" },
    width: 200,
    fixed: "right",
    align: "center",
  },
];

const actions = [
  {
    key: "history",
    value: "history",
    title: "History",
  },
  {
    key: "edit",
    value: "edit",
    title: "Edit",
  },
  {
    key: "remove",
    value: "remove",
    title: "Remove",
  },
];

let displayFields = {
  employee: "Employee",
  role: "Role",
  leaveHour: "Leave hour(s)",
  leaveHours: "Leave hour(s)",
  description: "Note",
  applyDate: "Date applied",
  expireDate: "Date expired",
  update: "Updated by",
  remainHours: "Remaining",
  leaveDay: "Leave day(s)",
};

import moment from "moment";
import { convertObjectToParams } from "../../../../components/commons/commons";
import FilterLayout from "../../../../components/layouts/FilterLayout.vue";

// Input modal
import { Button, FilterCommon, Table } from "@/components";
import { mapState } from "vuex";
import HistoryGeneralConfiguration from "../../../../components/leave-management/HistoryGeneralConfiguration/HistoryGeneralConfiguration.vue";
import { ImportModal } from "@/components";
import InputModal from "../../../../components/leave-management/InputModal/InputModal.vue";
import BonusLeaveImportExcel from "./BonusLeaveImportExcel/BonusLeaveImportExcel.vue";
import BonusLeaveForm from "./Input/AddBonusLeave.vue";
// import { getMessages } from "../../../../../components/commons/commons";
import {
  BONUS_LEAVE,
  filtersJson,
  getMessageResponseType,
  handleMessagesAPI,
  PAGINATION_DEFAULT,
  TMS_ROLE_ADMIN,
  TMS_ROLE_HR,
  TMS_ROLE_HRM,
} from "@/utils";

export default {
  name: "BonusLeave",
  components: {
    FilterLayout,
    InputModal,
    BonusLeaveForm,
    HistoryGeneralConfiguration,
    BonusLeaveImportExcel,
    ImportModal,
    FilterCommon,
    Table,
    Button,
  },
  data() {
    return {
      formData: {},

      // handle show modal
      isVisibleModal: false,

      // handle show modal
      visibleModal: {
        create: false,
        edit: false,
        history: false,
        delete: false,
        import: false,
      },

      // handle import excel file modal
      visibleModalImport: false,
      displayHistoryFields: displayFields,

      form: this.$form.createForm(this, { name: "FilterBonusLeave" }),
      formItemLayout: {
        labelCol: { span: 24 },
        wrapperCol: { span: 24 },
      },
      decorators: {
        staff: ["staff"],
        division: ["division"],
        department: ["department"],
        date_applied: ["date_applied"],
        date_expired: ["date_expired"],
      },

      actions: actions,
      bonusLeaveColumns: bonusLeaveColumns,

      filter: PAGINATION_DEFAULT,
      dataFilterDefault: {},

      // pagination
      total: 0,

      sort: { direction: -1 },

      loadingDownload: false,
      BONUS_LEAVE,

      fetching: false,
      filterList: filtersJson[BONUS_LEAVE],
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.user.loading,
      bonusLeaves: (state) => state.bonusLeave.bonusLeaveList,
      departmentList: (state) =>
        state.application.departmentList.filter((v) => v.status == 1 && v.department_type.includes("Department")),

      divisionList: (state) =>
        state.application.departmentList.filter((v) => v.status == 1 && v.department_type.includes("Division")),

      historyBonusLeaveList: (state) => state.bonusLeave.historyBonusLeaveList,
      userInfo: (state) => state.user.userInfo,
    }),
    checkShowAction() {
      const {
        userInfo: { roles },
      } = this;
      return roles?.some((role) => [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN].includes(role));
    },
  },
  created() {
    this.getBonusLeaveList();
    // this.getFilterData();
  },
  watch: {
    filter() {
      this.getBonusLeaveList();
    },
  },
  methods: {
    mappingStaffName(record) {
      try {
        let result = record.employee.name;
        if (record.employee.department_name && record.employee.department_name.name) {
          result = `${result} - ${record.employee.department_name.name}`;
        }

        const ldap = record.employee.user_name;
        result = `${result} (${ldap})`;
        return result;
      } catch {
        return "";
      }
    },

    async downloadTemplate() {
      this.loadingDownload = true;
      try {
        const res = await this.$store.dispatch("bonusLeave/downloadTemplate");
        handleMessagesAPI(res?.headers);
      } catch (error) {
        const errorObject = await getMessageResponseType(error);
        handleMessagesAPI(errorObject);
      } finally {
        setTimeout(() => {
          this.loadingDownload = false;
        }, 500);
      }
    },
    async onImport(values, onSuccess) {
      try {
        this.fetching = true;
        const res = await this.$store.dispatch("bonusLeave/importFile", values);
        const { code } = res?.headers;
        handleMessagesAPI(res?.headers);
        if (code == 200) {
          this.getBonusLeaveList();
          onSuccess();
          this.onCancelImportFile();
        }
      } catch (error) {
        const errorObject = await getMessageResponseType(error);
        handleMessagesAPI(errorObject);
      } finally {
        this.fetching = false;
      }
    },

    /**
     * Handle action click icon in table
     */
    onAction({ type, data }) {
      switch (type) {
        case "history":
          this.historyItem(data);
          break;

        case "edit":
          this.editItem(data);
          break;

        // delete
        default:
          this.removeItem(data);
          break;
      }
    },

    handleFilter(filter) {
      const { applyFromDate, applyToDate, expireFromDate, expireToDate } = filter;
      !applyFromDate && delete this.filter?.applyFromDate;
      !applyToDate && delete this.filter?.applyToDate;
      !expireFromDate && delete this.filter?.expireFromDate;
      !expireToDate && delete this.filter?.expireToDate;

      this.filter.page = 1;
      this.filter = { ...this.filter, ...filter };
    },

    handleImportFile() {},

    handleResetFilter() {},

    showModal(conditionField, newData) {
      this.visibleModal[conditionField] = true;

      if (newData) {
        this.formData = newData;
      }
    },
    showImportFileModal() {
      this.visibleModalImport = true;
    },

    onCancelImportFile() {
      this.visibleModalImport = false;
    },

    initCreatedData() {
      return {
        usernames: [],
        displayNames: [],
        leaveDay: null,
        description: "",
        applyDate: null,
        expireDate: null,
      };
    },
    createItem() {
      this.showModal("create", this.initCreatedData());
    },
    historyItem(record) {
      const getHistoriesUrl = convertObjectToParams({
        id: record.id,
      });

      this.$store.dispatch("bonusLeave/historyBonusLeaveList", getHistoriesUrl);
      this.showModal("history", record);
    },
    editItem(record) {
      const dataEdit = this.initCreatedData();
      dataEdit.id = record.id;
      dataEdit.employeeId = record.employeeId;
      dataEdit.usernames = record.username;
      dataEdit.displayNames = [this.mappingStaffName(record)];
      dataEdit.leaveHour = record.leaveHour;
      dataEdit.description = record.description;
      dataEdit.applyDate = moment(record.applyDate, "DD/MM/YYYY");
      dataEdit.expireDate = moment(record.expireDate, "DD/MM/YYYY");
      dataEdit.createdBy = record.createdBy;
      dataEdit.modifiedBy = record.modifiedBy;
      dataEdit.modifiedDate = record.modifiedDate;
      this.showModal("edit", dataEdit);
    },

    removeItem(record) {
      this.showModal("delete", record);
    },

    handleOk(conditionField, refForm = "") {
      this.fetching = true;
      const callback = (success = true, isEdit = null) => {
        if (success) {
          this.visibleModal[conditionField] = false;
          if (isEdit != null && isEdit == false) {
            this.filter.page = 1;
          }
          this.getBonusLeaveList();
        }
        this.fetching = false;
      };

      // handle logic code on own components
      if (!refForm) {
        this.onDeleteItem(this.formData, callback);
        return;
      }

      this.$refs[refForm].handleOk(callback);
    },
    handleFormatHistoryData(rawData) {
      let updatedInfo = null;
      if (rawData.modifiedBy) {
        let modifiedDate = moment(rawData.modifiedDate, "DD/MM/YYYY HH:mm").format("DD/MM/YYYY HH:mm");
        updatedInfo = rawData.modifiedBy
          ? `${rawData.modifiedBy.name} - ${rawData.modifiedBy.departmentName}<br/>${modifiedDate}`
          : "";

        this.displayHistoryFields.update = "Updated by";
      } else {
        let createdDate = moment(rawData.createdDate, "DD/MM/YYYY HH:mm").format("DD/MM/YYYY HH:mm");
        updatedInfo = rawData.createdBy
          ? `${rawData.createdBy.name} - ${rawData.createdBy.departmentName}<br/>${createdDate}`
          : "";

        this.displayHistoryFields.update = "Created by";
      }

      return {
        employee: `${this.mappingStaffName(rawData)}`,
        role: `${rawData.employee.role}`,
        leaveHour: `${rawData.leaveHour.toFixed(2)} hour(s)`,
        description: `${rawData.description ? rawData.description : ""}`,
        applyDate: `${rawData.applyDate}`,
        expireDate: `${rawData.expireDate}`,
        update: updatedInfo,
      };
    },
    handleCancel(conditionField) {
      this.visibleModal[conditionField] = false;
    },

    /**
     * Delete item in table list
     * @param {*} record item
     */
    onDeleteItem(record, callback) {
      this.deleteBonusLeave(record, callback);
    },

    /**
     * Get all bonus leave
     */
    getBonusLeaveList() {
      this.$store.dispatch("user/loadingRequest");
      const { sort, filter } = this;
      const param = { ...filter, ...sort };

      const url = convertObjectToParams(param);

      this.$store
        .dispatch("bonusLeave/getBonusLeaveList", url)
        .then((res) => {
          if (res.data) {
            this.total = res.page.total_element;
            this.firstCall = false;
          }
        })
        .catch((error) => {
          handleMessagesAPI(error.response.data);
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
    },

    deleteBonusLeave(record, callback) {
      this.$store
        .dispatch("bonusLeave/deleteBonusLeave", record.id)
        .then((res) => {
          const { code } = res;
          handleMessagesAPI(res);
          if (code == 200) {
            callback();
          }
        })
        .catch((error) => {
          handleMessagesAPI(error.response.data);
          this.fetching = false;
        });
    },

    onChangePage(payload) {
      this.filter = { ...this.filter, ...payload };
    },

    getFilterData() {
      // this.$store.dispatch("application/getDepartmentList");
      // this.$store.dispatch("filters/getEmployeeList", "");
      // this.$store.dispatch("bonusLeave/historyBonusLeaveList");
    },
  },
  mounted() {},
  destroyed() {},
};
